import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { GraduationCap, Sun, Shield, Volume2, BarChart3, Leaf } from 'lucide-react';

export default function CampusesPage() {
  return (
    <SolutionPageTemplate
      slug="campuses"
      title="BESS for Universities & Campuses"
      subtitle="Education & Campuses"
      description="Campus-wide reliable backup with smart energy management. Combine solar integration with storage for sustainable, cost-effective campus power."
      heroImage="/images/voltide-university.png"
      path="/solutions/campuses"
      sectorLabel="campuses"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: GraduationCap, title: 'Campus-Wide Backup', desc: 'Cover classrooms, labs, hostels, and admin buildings with a single system.' },
        { icon: Sun, title: 'Solar Integration', desc: 'Pair with rooftop solar across campus buildings for maximum savings.' },
        { icon: Volume2, title: 'Silent Campus', desc: 'No DG noise during exams, lectures, or library hours.' },
        { icon: Leaf, title: 'Sustainability Goals', desc: 'Demonstrate environmental leadership. Align with green campus certifications.' },
        { icon: Shield, title: 'Lab Protection', desc: 'Protect sensitive lab equipment and research data from power fluctuations.' },
        { icon: BarChart3, title: 'Energy Education', desc: 'Use the BESS monitoring dashboard as a teaching tool for engineering students.' },
      ]}
      howItWorks={[
        { title: 'Campus Energy Audit', desc: 'We map power demand across buildings, identify critical loads, and assess solar potential.' },
        { title: 'Phased Deployment', desc: 'Start with critical buildings, expand to full campus. Modular systems grow with your needs.' },
        { title: 'Smart Campus Grid', desc: 'Integrated EMS manages solar, storage, and grid across the entire campus network.' },
      ]}
      faqs={[
        { q: 'Can one BESS system cover an entire campus?', a: 'Larger campuses typically need multiple distributed systems. We design optimal placement to minimize cable runs and maximize coverage.' },
        { q: 'How does this work with existing solar panels?', a: 'BESS integrates with your existing rooftop solar setup. We store excess generation during the day for use during evening hours and outages.' },
        { q: 'What about hostels that need 24/7 power?', a: 'BESS provides seamless backup for hostel common areas, lifts, and water pumps. For extended outages, the system can be sized for overnight coverage.' },
      ]}
    />
  );
}
